export const SPOTIFY_CONFIG = {
  clientId: import.meta.env.VITE_SPOTIFY_CLIENT_ID || '',
  clientSecret: import.meta.env.VITE_SPOTIFY_CLIENT_SECRET || '',
  redirectUri: import.meta.env.VITE_SPOTIFY_REDIRECT_URI || 'https://a5omic.com/callback'
};

// Debug log for environment variables
// console.log('Spotify Config Loaded:', {
//   hasClientId: !!SPOTIFY_CONFIG.clientId,
//   hasClientSecret: !!SPOTIFY_CONFIG.clientSecret,
//   redirectUri: SPOTIFY_CONFIG.redirectUri,
//   envVars: {
//     VITE_SPOTIFY_CLIENT_ID: !!import.meta.env.VITE_SPOTIFY_CLIENT_ID,
//     VITE_SPOTIFY_CLIENT_SECRET: !!import.meta.env.VITE_SPOTIFY_CLIENT_SECRET,
//     VITE_SPOTIFY_ARTIST_ID: import.meta.env.VITE_SPOTIFY_ARTIST_ID || 'not set'
//   }
// }); 